var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPipl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_39_17916)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M45.1429 7.14319H5.85714C2.89847 7.14319 0.5 9.54166 0.5 12.5003V37.5003C0.5 40.459 2.89847 42.8574 5.85714 42.8574H45.1429C48.1015 42.8574 50.5 40.459 50.5 37.5003V12.5003C50.5 9.54166 48.1015 7.14319 45.1429 7.14319ZM46.9285 27.8324L35.6911 16.595C34.9938 15.8978 33.8634 15.8978 33.1661 16.595L18.3572 31.4038L12.4768 25.5234C11.7795 24.8263 10.6491 24.8263 9.95179 25.5234L4.07139 31.4038V12.5003C4.07139 11.5141 4.87088 10.7146 5.85714 10.7146H45.1429C46.1291 10.7146 46.9286 11.5141 46.9286 12.5003V27.8324H46.9285Z",
    fill: "#7B7B7B"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.5714 24.9998C19.53 24.9998 21.9285 22.6013 21.9285 19.6427C21.9285 16.684 19.53 14.2855 16.5714 14.2855C13.6127 14.2855 11.2142 16.684 11.2142 19.6427C11.2142 22.6013 13.6127 24.9998 16.5714 24.9998Z",
    fill: "#7B7B7B"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_17916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipl);
export default __webpack_public_path__ + "static/media/pipl.9ceb3f8d325e38937fb11c7cf029d546.svg";
export { ForwardRef as ReactComponent };